import {gql, useMutation} from "@apollo/client";

const EDIT_ORG_MUTATION = gql`
mutation EditTeam($name: String!, $organizationType: String!, $orgId: Int!, $location: LocationInput, $waiverIds: [ID], $fieldIds: [Int], $sanctionRuleId: ID, $stripeAccountId: ID, $currency: String) {
  editTeam(name: $name, organizationType: $organizationType, orgId: $orgId, location: $location, waiverIds: $waiverIds, fieldIds: $fieldIds, sanctionRuleId: $sanctionRuleId, stripeAccountId: $stripeAccountId, currency: $currency) {
    organization {
       slug
        name
        organizationType {
            code
        }
        divisionsCount
        logo
        id
        address
        currency
        waivers {
            id
            title
        }
        fields{
            id
            name
            description
        }
        sanctionRule{
            id
            name
        }
        stripeAccount{
            id
            name
        }
    }
  }
}
`;

export default function EditOrgMutation() {
    return useMutation(EDIT_ORG_MUTATION);
}
